import Vue from 'vue';
import Vuex from 'vuex';
import Cookie from 'js-cookie';
import {beforeSend, safeOpenTab, user} from '@/znzs/src/utils/index';
import {getTicketInfo, handleAfterUserAction} from '@/znzs/src/utils/chat';
import {
    knowledgeEvaluateOptions,
    robotConfigs,
    getWelcomeWords,
    guessWantToAsk,
    userSubmitQuestion,
} from '@/znzs/src/api/robot.js';
import {getAllTicketsProductQuestionTypes} from '@/znzs/src/api/chat.js';
import {getTicketType} from '@/znzs/src/api/robot';
import {constant, DISPLAY_TYPE, CHANNEL, QUESTION_TRIGGER} from '@/znzs/src/utils/enum';
import chat from './chat.module';

Vue.use(Vuex);

export default (options = {}) => new Vuex.Store({
    state: {
        isLogin: true,
        // 是否售前
        isPresale: true,
        // 是否是游客
        isTourist: false,
        knowledgeOptions: [],
        // 最新聊天记录list
        chattingRecordsLists: [],
        // 机器人头像和名称配置
        robotConfig: {},
        // 欢迎语
        welcomeSpeechs: {},
        // 从工单跳转过来携带的产品类型和问题类型id
        ticketTypeIds: {
            productId: 0,
            questionId: 0,
            znzsSessionId: '',
        },
        // 是否已触发自动问，用于常驻入口的接口调用判断
        autoAsked: false,
        // 会话来源
        source: '',
        hasSource: true,
        // 全局顶部banner
        globalTopBannerVisible: true,
        // 全部云产品的产品类型和问题类型
        ticketsProductQuestionTypes: [],
    },
    getters: {
        chattingRecordsLists(state) {
            return state.chattingRecordsLists;
        },
        ticketTypeIds(state) {
            return state.ticketTypeIds;
        },
        // 获取游客名字，登录用户返回名字
        touristUserName(state) {
            let name = '';
            if (state.isTourist) {
                const id = Cookie.get('BAIDUID').slice(0, 10);
                name = `游客${id}`;
            }
            else {
                // 售前
                name = user.name;
            }
            return name;
        },
        /**
         * 当前是否处于文心loading状态，需要禁用如下交互
         * 点击匹配行为，包括猜你想了解、快捷导航、自助工具
         * 发送消息
         * 粘贴图片并发送
         * 通过附件上传图片并点击发送
         * 点击右侧创建工单入口
         * 点击历史消息中的提交工单、自助工具等入口
         */
        isInWenxinLoading(state) {
            return state.chattingRecordsLists.some(record => record.dialogInfo.display === DISPLAY_TYPE.ERNIE_LOADING);
        },
        getPreviousDialogById(state) {
            return id => {
                let prev = null;
                const finded = state.chattingRecordsLists.some(item => {
                    if (item.dialogId !== id) {
                        prev = item;
                    }
                    return item.dialogId === id;
                });
                if (finded) {
                    return prev;
                }
                return {};
            };
        },
    },
    mutations: {
        setKonwageOptions(state, list) {
            state.knowledgeOptions = list;
        },
        setChatRecordsList(state, list) {
            state.chattingRecordsLists = state.chattingRecordsLists.concat(list);
        },
        removeChatRecord(state, id) {
            const recordsList = state.chattingRecordsLists;
            const loadingIndex = recordsList.findIndex(record => record.dialogId === id);
            if (loadingIndex > -1) {
                recordsList.splice(loadingIndex, 1);
                state.chattingRecordsLists = [...recordsList];
            }
        },
        adjustChatRecordsList(state, lists) {
            state.chattingRecordsLists = lists;
        },
        replaceChatRecordsList(state, item) {
            state.chattingRecordsLists = state.chattingRecordsLists.map(dialog => {
                if (dialog.dialogId !== item.dialogId) {
                    return dialog;
                }
                return item;
            });
        },
        setRobotConfig(state, list) {
            state.robotConfig = list;
        },
        setWelcomeSpeechs(state, obj) {
            state.welcomeSpeechs = obj;
        },
        setIsLogin(state, login) {
            state.isLogin = login;
        },
        setTourist(state) {
            state.isTourist = true;
        },
        /**
         * 默认游客模式是售前模式
         * @param {*} state
         * @param {*} presale
         */
        setPresale(state, presale) {
            state.isPresale = state.isTourist || presale;
        },
        setTicketTypeIds(state, obj) {
            state.ticketTypeIds = obj;
        },
        updateTicketTypeIds(state, obj) {
            const currentIds = {
                productId: state.ticketTypeIds.productId || obj.productId,
                questionId: state.ticketTypeIds.questionId || obj.questionId,
                znzsSessionId: state.ticketTypeIds.znzsSessionId,
            };
            state.ticketTypeIds = currentIds;
        },
        setAutoAsked(state, data) {
            state.autoAsked = data;
        },
        // 将source put到路径参数中保存起来
        getSource(state, path) {
            if (location.search) {
                const matchSource = location.search.match(/source=[^$&#]*/);
                if (matchSource && matchSource[0]) {
                    let appPath = '/znzs/robot-chat';
                    const matched = path.match(/^\/znzs\/[^\/]+/);
                    if (matched) {
                        appPath = matched[0];
                    }
                    const source = matchSource[0].split('=')[1];
                    const computedSource = encodeURIComponent(source);
                    location.hash = `#${appPath}/${computedSource}`;
                    let newSearch = location.search.slice(0, matchSource.index - 1)
                        + location.search.slice(matchSource.index + matchSource[0].length);
                    if (newSearch && !newSearch.includes('?')) {
                        newSearch.replace('&', '?');
                    }
                    if (newSearch) {
                        location.search = newSearch;
                    }
                    else {
                        location.href = location.href.replace(location.search, '');
                    }
                }
            }
            state.hasSource = false;
        },
        setSource(state, {source, onError}) {
            try {
                state.source = decodeURIComponent(source);
            }
            catch {
                if (onError) {
                    onError();
                }
            }
        },
        setTicketsProductQuestionTypes(state, list) {
            state.ticketsProductQuestionTypes = list;
        },
        setGlobalTopBanner(state, visible) {
            state.globalTopBannerVisible = visible;
        },
    },
    actions: {
        GET_KNOWLEDGEOPTIONS({commit}) {
            return knowledgeEvaluateOptions().then(res => {
                if (res.success) {
                    commit('setKonwageOptions', res.data.badTerms);
                }
            });
        },
        GET_ROBOTCONFIG({commit}) {
            return robotConfigs().then(res => {
                if (res.success) {
                    commit('setRobotConfig', res.data);
                }
            });
        },
        /**
         * 获取欢迎语
         */
        GET_WELCOMESPEECHS({commit}) {
            return getWelcomeWords({userName: user.name}).then(res => {
                if (res.success) {
                    commit('setWelcomeSpeechs', res.data);
                }
            });
        },
        /**
         * @description:  获取全部云产品的产品类型和问题类型
         */
        async queryTicketsProductQuestionTypes({commit}, payload) {
            const res = await getAllTicketsProductQuestionTypes();
            if (res.success) {
                commit('setTicketsProductQuestionTypes', res.data);
            }
        },
        async getCurrentTicketType({commit}) {
            try {
                const {data, success} = await getTicketType();
                if (success) {
                    commit('setTicketTypeIds', data);
                }
                return data;
            }
            catch {
                return {};
            }
        },
        /**
         * 售前模式下，提交工单直接打开窗口
         */
        async openTicketWindow({state}, {url = constant.true.createTicketLink, params = {}}) {
            const searchParams = new URLSearchParams();
            for (const key of Object.keys(params)) {
                if (params[key]) {
                    searchParams.set(key, params[key]);
                }
            }

            searchParams.set('channel', 2);
            let href = `${url}&${searchParams.toString()}`;
            href = href.replace(/\?|~/g, '&').replace('&', '?');
            // 非游客模式下，去除地址前面的域名部分
            if (!state.isTourist) {
                if (href.startsWith(constant.true.ticketDomain)) {
                    href = href.replace(constant.true.ticketDomain, '/ticket');
                }
                else if (href.startsWith(location.origin)) {
                    href = href.replace(location.origin, '');
                }
            }
            if (window.isSupport) {
                window.top.postMessage({
                    channel: 'jump',
                    data: {
                        url: href,
                    },
                });
            }
            else {
                safeOpenTab(href, false, false);
            }
        },
        /**
         * 推出创建工单的卡片
         * 已经收敛到通过useTransformTicket来调用，后续相关逻辑挪到new_src下
         * @params useTicketId 是否使用提单路径的分类id
         */
        async transformTicket({state, dispatch, commit}, {
            href = constant.true.createTicketLink,
            useTicketId = true,
            ids = {},
            checkLoading = true,
            checkPermission,
        }) {
            try {
                if (checkLoading && beforeSend(this)) {
                    return;
                }
                // 检查是否在IM流程中
                const inIM = await dispatch('chat/checkSocket');
                if (inIM) {
                    return;
                }
                let info = {...ids};

                // 售前跳工单链接
                if (state.isPresale) {
                    // 游客模式打开
                    if (!state.isLogin) {
                        this.dispatch('openTicketWindow', {url: href, params: {}});
                    }
                    else {
                        // 转工单需要有三级类型
                        if (!info.questionId) {
                            const {params} = await getTicketInfo(href, useTicketId);
                            info = params;
                            commit('setTicketTypeIds', params);
                        }
                        this.dispatch('openTicketWindow', {url: href, params: info});
                    }
                }
                // 推出工单卡片
                else {
                    if (!checkPermission()) {
                        return;
                    }
                    const {data} = await userSubmitQuestion({
                        trigger: QUESTION_TRIGGER.CREATE_TICKET,
                        channel: CHANNEL,
                        content: '触发提交工单卡片',
                        userName: user.name,
                    });
                    // 转工单需要有三级类型，但当前的逻辑有可能三级类型是丢失的，比如从部分挂件进来
                    // info中的工单类型不在这里获取了，而是在卡片中通过一个新的接口去获取
                    // 目前灰度阶段，暂时保留
                    if (!info.questionId) {
                        const {params} = await getTicketInfo(href, useTicketId);
                        info = params;
                        commit('setTicketTypeIds', params);
                    }
                    data.dialogInfo.ticketInfo = info;
                    handleAfterUserAction(data);
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    },
    modules: {
        chat,
    },
    ...options,
});
